import React from 'react';
const StarIcon = ({width, height}) => {
    const star = require('../Images/star.png');
    return (
        <img src={star} height={height} width={width}/>
    );
};
 
export default StarIcon